import { Component, OnInit, OnDestroy } from '@angular/core';
import { LangService } from '../../core/lang.service';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../api/auth.service';
import { RoutesService } from '../../api/routes.service';
import { ScrollService } from '../../core/scroll.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { Subscription } from 'rxjs';
import { AUTH_REG_ERROR } from '../../api/constants/registration-validation';



@Component({
  selector: 'confirm-registration',
  templateUrl: './confirm-registration.component.html',
  styleUrls: ['./confirm-registration.component.scss']
})
export class ConfirmRegistrationComponent implements OnInit, OnDestroy {

  constructor(
    public lang: LangService,
    private loginGuard: LoginGuardService,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private routes: RoutesService,
    private scrollService: ScrollService,
  ) { }

  routeSub: Subscription;
  breadcrumb = [];
  email: string;
  activationKey: string;
  isActivated: boolean;
  loginRoute: string;
  isError: boolean;
  isLoading: boolean;
  errorType: string;
  AUTH_REG_ERROR = AUTH_REG_ERROR;

  ngOnInit() {
    this.loginGuard.deactivate();
    this.scrollService.scrollToTop();
    this.routeSub = this.route.params.subscribe(routeParams => {
      const emailEncoded = routeParams['emailEncoded'];
      this.email = decodeURIComponent(emailEncoded);
      this.activationKey = routeParams['activationKey'];
      this.initRouteView();
    });
  }

  initRouteView() {
    this.activateAccount(this.email, this.activationKey);
    this.loginRoute = ['',
      this.lang.c(),
      'default',
      'login',
      true // dont logout
    ].join('/');
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  activateAccount(email: string, emailVerifCode: string) {
    this.auth
      .apiPatch(
        this.routes.AUTH_CONFIRM_EMAIL,
        null,
        {email, emailVerifCode}
      )
      .then(res => {
        this.isActivated = true;
        this.loginRoute = ['',
          this.lang.c(),
          res.account_type,
          'login',
          encodeURIComponent(email),
          true // dont logout
        ].join('/');
        // console.log(this.loginRoute)
      })
      .catch(err => {
        this.errorType = err.message;
        this.isError = true;
      });
  }

}
